/**
 * side navigation functionality
 *
 * @since 1.1.0
 * @package lockbusters
 */
(function($) {
	$(document).ready(function(){
		var singlePageMenuModule = (function() {
			var init = function () {
                // add 'active-page' class to current single room page menu item
                var $rightNavList = document.querySelectorAll('.right-nav ul li');
                var $body = document.querySelector('body');
                var bodyClassList = $body.classList;
                if ( bodyClassList.contains('serial-killer') ) {
                    $rightNavList[0].classList.add('active-page');
                } if ( bodyClassList.contains('bank-heist') ) {
                    $rightNavList[1].classList.add('active-page');
                } if ( bodyClassList.contains('pirate-adventure') ) {
                    $rightNavList[2].classList.add('active-page');
                } if ( bodyClassList.contains('war-room') ) {
                    $rightNavList[3].classList.add('active-page');
                } if ( bodyClassList.contains('alien-invasion') ) {
                    $rightNavList[4].classList.add('active-page');
                }
                // if current page is a single room page,
                // onclick remove 'active' class from other
                // menu items and if clicked menu item doesnt has 'active class, add it
                if ($('body').hasClass('page-template-page-rooms')) {
                    $('.right-nav li a').click(function(e) {
                        $('.right-nav li').removeClass('active');
                        var $parent = $(this).parent();
                        if (!$parent.hasClass('active')) {
                            $parent.addClass('active');
                        }
                        e.preventDefault();
                    });
                    // remove from prev and add 'active' class on hover to currently hovered item
                    // when not hovering 'ul' remove 'active' from all
                } else {
                    $('.right-nav li a').hover(function(e) {
                        $('.right-nav li').removeClass('active');
                        var $parent = $(this).parent();
                        if (!$parent.hasClass('active')) {
                            $parent.addClass('active');
                        }
                    });
                    $('.right-nav ul').mouseleave(function(e) {
                        $('.right-nav li').removeClass('active');
                    });
                }
			}

			return {
				init: init
			}
		})();

		singlePageMenuModule.init();
	});
})(jQuery);
